<template>

  <div style="padding: 310px 80px 0 80px">
    <el-row :gutter="60">
      <el-col :span="24" class="card-01">
        <el-row :gutter="20">
          <el-col :span="24" class="modal_title middle_blue">Přehledy
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="7">
            <el-row>
              <el-col>
                <div class="modal_title green">Operace</div>
              </el-col>
              <el-col class="card-modal middle_blue gr-min-h">
                <div id="graf_01" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="7">
            <el-row>
              <el-col>
                <div class="modal_title green">Léčba</div>
              </el-col>
              <el-col class="card-modal middle_blue gr-min-h">
                <div id="graf_02" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="7">
            <el-row>
              <el-col>
                <div class="modal_title green">Ostatní</div>
              </el-col>
              <el-col class="card-modal middle_blue gr-min-h">
                <div id="graf_03" />
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>



    <el-dialog :visible.sync="modal_dashboard" width="80%" custom-class="my-dialog-01" headerClasses="justify-content-center" :show-close="false" center :close-on-click-modal="false" :close-on-press-escape="false">
      <el-row :gutter="20" class="card-modal-01">
        <el-col :span="24">

          <el-row :gutter="20" class="card-modal-02">
              <h5 class="modal_title_2">Xxx</h5>
              <el-col :span="4">
                <div class="form-group">
                  <div class="modal_label_dark_green"> ID Dashboard</div>
                  <el-input type="text"
                            placeholder="Xxx"
                            v-model="dashboard_id_dashboard">
                  </el-input>
                </div>
              </el-col>
           </el-row>
        </el-col>
      </el-row>
      <template slot="footer">
        <el-button v-if="dashboard.id_dashboard === 0" class="btn-green-big" link @click.native="dashboard_new_save"><i class="el-icon-finished"></i> ULOŽIT </el-button>
        <el-button v-if="dashboard.id_dashboard !== 0" type="info" link @click.native="dashboard_edit_save"><i class="el-icon-finished"></i> EDITOVAT </el-button>
        <el-button class="btn-blue" link @click.native="modal_dashboard_close"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
      </template>

    </el-dialog>

  </div>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import Examinations from 'src/components/Views/Examinations.vue';
  import ApexCharts from 'apexcharts'

  const nthOptions = ['Cefalea', 'Porucha vědomí'];

  export default {
    components: {
      Examinations,

    },

    data () {
      return {
        props: {
          multiple: true,
        },

      }
    },


    computed: {
      ...mapState({
        token: state => state.token,
        dashboard: state => state.dashboard,
        dashboard_default: state => state.dashboard_default,
        dashboards: state => state.dashboards,


        modal_dashboard: state => state.modal_dashboard,
        sorting_dashboards: state => state.sorting_dashboards,
        pagination_dashboards: state => state.pagination_dashboards,
        loading_dashboards: state => state.loading_dashboards,



      }),

      ...mapGetters({

      }),


      filter_select_column: {
        get () { return this.$store.state.filter_select_column; },
        set (value) { this.$store.commit('m_filter_select_column', value); }
      },

      filter_select_value: {
        get () { return this.$store.state.filter_select_value; },
        set (value) { this.$store.commit('m_filter_select_value', value); }
      },

      dashboard_id_dashboard: {
        get () { return this.dashboard.id_dashboard; },
        set (value) { let mykey = "id_dashboard"; this.m_dasboard_item( {mykey, value} ); }
      },




    },

    methods: {
      ...mapMutations({
        m_dashboard_item: 'm_dashboard_item',
        m_modal_dashboard: 'm_modal_dashboard',
        m_dashboard_reset: 'm_dashboard_reset',
        m_dashboard_id: 'm_dashboard_id',
        m_dashboard: 'm_dashboard',


      }),


      ...mapActions({
        a_dashboard: 'a_dashboard',
        a_dashboard_new: 'a_dashboard_new',
        a_dashboard_update: 'a_dashboard_update',
        a_dashboards: 'a_dashboards',

      }),


      onSubmit() {
        console.log('submit!');
      },


      change_lr_req_insu_num(value) {
        let validni = true

        if ((value.length  > 5) && (/^0?\d+$/.test(value))) {
          let yy = '';
          let mm = '';
          let dd = '';

          for (let strIndex in value) {
            if (strIndex == 0) {
              yy += value[strIndex];
            }
            else if (strIndex == 1) {
              yy += value[strIndex];
            }
            else if (strIndex == 2) {
              mm += value[strIndex];
            }
            else if (strIndex == 3) {
              mm += value[strIndex];
            }
            else if (strIndex == 4) {
              dd += value[strIndex];
            }
            else if (strIndex == 5) {
              dd += value[strIndex];
            } else {

            }
          }
          let xyy = parseInt(yy);
          let xmm = parseInt(mm);
          let xdd = parseInt(dd);
          let xgender = "";

          if (xyy > 21) {
            xyy = 1900 + xyy;
          } else {
            xyy = 2000 + xyy;
          }

          if (xmm < 13) {
            xgender = "2";
            xmm -= 1;
          } else if (xmm > 50 && xmm < 63) {
            xgender = "1";
            xmm -= 51;
          } else {
            xgender = "0";
            xmm = 0;
          }

          if (xdd > 31) {
            xdd -= 50;
          }

          this.m_lab_req_birth_date( {xyy: xyy, xmm: xmm, xdd: xdd});
          this.m_lab_req_gender(xgender);
        }
      },


      change_inco(value) {
        console.log(value);

      },


      dashboard_new() {
        this.m_dashboard( this.dashboard_default );
        this.m_modal_dashboard(true);
      },


      dashboard_new_save() {
      let valid = true;
      let valid_text = "";

      if ( this.dashboard_id_dashboard.length === 0  ) {
        valid = false;
        valid_text += "<p>ID dashboard je vyžadováno.</p>";
      }

      else {
        this.$alert(valid_text, 'Title', {
          confirmButtonText: 'OK',
          dangerouslyUseHTMLString: true
          });
        }
      },


      dashboard_edit (index, row, event) {
        event.stopImmediatePropagation();
        this.dashboard.id_dashboard = row.id_dashboard;
        this.a_dashboard( {'id_dashboard': row.id_dashboard} );
        this.m_modal_dashboard(true);
      },


      dashboard_edit_save() {
        this.a_dashboard_update( this.dashboard );
        this.m_modal_dashboard(false);
      },


      dashboard_delete (index, row, event) {
        event.stopImmediatePropagation();
        this.a_dashboard_delete( {'id_dashboard': row.id_dashboard} );
      },


      modal_dashboard_close() {
        this.m_dashboard_reset();
        this.m_modal_dashboard(false);
      },


      CurrentChange_dashboards(val) {
        //event.stopImmediatePropagation();
        console.log(val.id_dashboard);
        if (val.id_dashboard > 0) {
          this.m_dashboard_id(val.id_dashboard);
          //this.a_examinations( {"id_patient": val.id_patient} );
        } else {
          this.m_dashboard_id(0);
          //this.a_examinations( {} );
        }

      },


      SortChange_dashboards(val) {
        // event.stopImmediatePropagation();
        this.sorting_dashboards.sorting_prop = val.prop;
        this.sorting_dashboards.sorting_ordering = val.order;
        this.pagination_dashboards.currentPage = 1;
        this.a_dashboards();
      },


      CurrentChangePage_pagination_dashboards(val) {
        this.pagination_dashboards.currentPage = val;
        this.a_dashboards();
      },


      SizeChangePage_pagination_dashboards(val) {
        this.pagination_dashboards.perPage = val;
        this.pagination_dashboards.currentPage = 1;
        this.a_dashboards();
      },


      SortChange_dashboards(val) {
        // event.stopImmediatePropagation();
        // console.log(val);
        this.sorting_dashboards.sorting_prop = val.prop;
        this.sorting_dashboards.sorting_ordering = val.order;
        this.pagination_dashboards.currentPage = 1;
        this.a_dashboards();
      },


      get_graf_01 () {
        var options = {
          chart: {
            type: 'line',
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true | '<img src="/static/icons/reset.png" width="20">',
                customIcons: []
              },
              export: {
                csv: {
                  filename: undefined,
                  columnDelimiter: ',',
                  headerCategory: 'category',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  }
                },
                svg: {
                  filename: undefined,
                },
                png: {
                  filename: undefined,
                }
              },
              autoSelected: 'zoom'
            },


          },
          series: [{
            name: 'sales',
            data: [60, 70, 91, 125]
          }
        ],
          xaxis: {
            categories: [2020, 2021, 2022, 2023]
          },
        stroke: {
          curve: 'smooth',
        },
        }

        var chart_01 = new ApexCharts(document.querySelector("#graf_01"), options);
        chart_01.render();
      },


    get_graf_02() {
      var options = {
        chart: {
          type: 'bar',
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: true,
              selection: false,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true | '<img src="/static/icons/reset.png" width="30">',
              customIcons: []
            },
            export: {
              csv: {
                filename: undefined,
                columnDelimiter: ',',
                headerCategory: 'category',
                headerValue: 'value',
                dateFormatter(timestamp) {
                  return new Date(timestamp).toDateString()
                }
              },
              svg: {
                filename: undefined,
              },
              png: {
                filename: undefined,
              }
            },
            autoSelected: 'zoom'
          },
        },

        series: [{
          data: [{
            x: 'Chemoterapie int.',
            y: 15
          }, {
            x: 'Udržovací terapie',
            y: 18
          }, {
            x: 'Biologická terapie',
            y: 12
          }, {
            x: 'Radioterapie',
            y: 13
          }, {
            x: 'Radiační nekróza',
            y: 19
          }]
        }],


      }

      var chart_02 = new ApexCharts(document.querySelector("#graf_02"), options);
      chart_02.render();
    },

    get_graf_03() {
      var  options = {

        chart: {
          type: 'donut',
        },

        series: [44, 55, 41, 17, 15],
         labels: ['ABC', 'EFG', 'KLM', 'OPR', 'XYZ'],

        plotOptions: {
          pie: {
            donut: {
              size: '70%',


              labels: {
                show: true,
                name: {
                  show: true,
                },
                value: {
                  show: true,
                },
                total: {
                  show: true,
                },
              },




            }
          }
        },

        colors: ['#2E93fA', '#81c37a', '#659aaf', '#2b5e73', '#31712a'],

      }

      var chart_03 = new ApexCharts(document.querySelector("#graf_03"), options);
      chart_03.render();
    },

    },


    beforeCreate () {
    },

    created () {
    },

    beforeMount () {
    },

    mounted () {
      this.get_graf_01();
      this.get_graf_02();
      this.get_graf_03();

    },

    beforeUpdate () {
    },

    updated () {

    },

    afterDestroy () {
    },

    destroyed () {
    },




  }
</script>

<style lang="scss" scoped>

.my-dialog-01 {
   background: #ebeff3 !important;
}

.el-select {
  padding: 0 20px !important;
}

.el-row {
  margin-bottom: 0px;
  &:last-child {
    margin-bottom: 0;
 }

.gr-min-h {
 min-height: 410px !important;
 }

}
</style>
